import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IAirbase, IAirbaseResponse } from "./IAirbaseResponse";

export const airBaseApi = createApi({
  reducerPath: "airBase",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.AIRBASE,
  }),
  endpoints: (builder) => ({
    getAll: builder.query<IAirbase[], void>({
      query() {
        return {
          url: "",
          method: "GET",
          credentials: "include",
        };
      },
    }),
    getOne: builder.query<IAirbase, number>({
      query(code) {
        return {
          url: `/code/${code}`,
          method: "GET",
          credentials: "include",
        };
      },
    }),
    getFilteredAirBases: builder.query<IAirbaseResponse, string>({
      query(searchParams) {
        return {
          url: `/pagination?${searchParams}`
        }
      },
    }),
  }),
});

export const {
  useGetAllQuery,
  useGetOneQuery,
  useGetFilteredAirBasesQuery,
} = airBaseApi;
